import { render, staticRenderFns } from "./Comment_List.vue?vue&type=template&id=e3f2b494&"
import script from "./Comment_List.vue?vue&type=script&lang=js&"
export * from "./Comment_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports